import React from "react";
import { motion } from "framer-motion";
import "./Vision.css"; // Import custom styles

const Vision = () => {
  return (
    <motion.div
      id="vision"
      className="container my-5"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.2 }}
    >
      <div className="row align-items-center">
        {/* Text Section */}
        <motion.div
          className="col-lg-6"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h1 className="about-heading fw-bold mb-4">Our Vision</h1>

          <p>
            To be a leader in Plastic Conversion while providing
            <strong> Quality, Technology & Professional Development</strong> to
            our customers and the market at all times.
          </p>

          <p>
            Going towards a continuous improvement plan and organizational
            activities at establishing our company as a pioneer supplier of
            high-quality plastic products, while serving both local and
            international markets alike.
          </p>
          <ul>
            <li>Integrity</li>
            <li>Reliability</li>
            <li>Efficiency</li>
            <li>Quality</li>
            <li>Constant Development</li>
          </ul>
        </motion.div>

        {/* Image Section */}
        <motion.div
          className="col-lg-6 text-center mt-4 mt-lg-0"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
          viewport={{ once: true }}
        >
          <img
            src="vision.png" // Replace with the correct image path
            alt="Vision and Mission"
            className=" w-75"
          />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Vision;
